import React, { Suspense, useEffect, useState } from 'react';
import { Button, List, Row, Col, Select , Spin , DatePicker, Typography, Divider } from 'antd';
import axios from 'axios';
import { formatDateWithTimezoneOffset, getMonthBoundaries, getCurrentDate } from '../../lib/lib';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import moment from 'moment';
import dayjs from 'dayjs';
import { CrownOutlined } from '@ant-design/icons';
import StableDatePicker from '../common/StableDatePicker';

const { RangePicker } = DatePicker;

const UserTopPage: React.FC = () => {
    let startDateParams;
    let endDateParams;
    let FilterTeamParams;
    const queryParams = new URLSearchParams(window.location.search);
    if (queryParams.has('startDate') && queryParams.has('endDate')) {
       startDateParams = queryParams.get('startDate');
       endDateParams = queryParams.get('endDate');
    }
    if(queryParams.has('FilterTeam')){
     FilterTeamParams = queryParams.get('FilterTeam');
    }
    
    const { firstDayIso, lastDayIso } = getMonthBoundaries(startDateParams ? startDateParams : null, endDateParams  ? endDateParams : null);
    const adjustedfirstDayOfMonth= formatDateWithTimezoneOffset(firstDayIso, 7);
    const adjustedlastDayOfMonth = formatDateWithTimezoneOffset(lastDayIso, 7);
    const [data, setData] = useState<any[]>([]);
    const [startDate, setStartDate] = useState<string | null>(adjustedfirstDayOfMonth);
    const [endDate, setEndDate] = useState<string | null>(adjustedlastDayOfMonth);
    const [selectedTeam, setSelectedTeam] = useState<string>(FilterTeamParams ? FilterTeamParams : 'ALL');
    const [FilterTeam] = useState<any[]>([
      { teamName: 'Team ALL', value: "ALL" },
      { teamName: 'Team OTHER', value: "OTHER" },
      { teamName: 'Team MARKETING', value: "MARKETING" },
    ]);
  
  
    const { Option } = Select;

      const handleTeamChange = (value: string) => {
        setSelectedTeam(value);
      };


      useEffect(() => {
        const fetchData = async () => {
          try {
            const currentDate = new Date();
            const previousMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, currentDate.getDate());
            const defaultEndDate = formatDateWithTimezoneOffset(currentDate, 0);
            const adjustedStartDate = formatDateWithTimezoneOffset(previousMonth, 0);
            const params: any = {
              startDate: startDate || adjustedStartDate,
              endDate: endDate || defaultEndDate
            }

            if (selectedTeam === 'ALL') {
              params.teamName = 'ALL';
            } else {
              params.teamName = selectedTeam;
            }
            const response = await axios.get('/api/transfers/users-tops', { params });
            setData(response.data.docs);
          } catch (error) {
            console.error('Error fetching data:', error);
          }
        };
      
        fetchData();
      }, [selectedTeam, startDate, endDate,FilterTeam ]);


    const handleDateChange = (dates: [dayjs.Dayjs, dayjs.Dayjs] | null, dateStrings: [string, string]) => {
      if (dateStrings) {
        console.log(dateStrings);
        setStartDate(dateStrings[0]);
        setEndDate(dateStrings[1]);
      }
    };

    const exportToExcel = async () => {

        const transformedData = data.map(item => ({
          "Họ Tên": item.receiverName,
          "Số Sao Nhận": item.totalValue,
          "Số sao tích luỹ": item.kudosSpendable,
          "Team": item.teamName
        }));
        const worksheet = XLSX.utils.json_to_sheet(transformedData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        const filename = `data_${getCurrentDate()}.xlsx`;
        saveAs(blob, filename);
    }
    
    // Component hiển thị huy chương
    const MedalIcon = ({ index }: { index: number }) => {
      if (index > 2) return null;

      const medalColors: Record<number, string> = {
        0: '#FFD700',
        1: '#C0C0C0', 
        2: '#CD7F32',
      };

      return (
        <CrownOutlined 
          style={{ 
            color: medalColors[index],
            fontSize: '20px',
            marginRight: '8px',
          }} 
        />
      );
    };

    return (
      <Suspense fallback={<Spin />}>
        <Typography.Title level={2}>Top Users</Typography.Title>
        <Divider />
        <div style={{ 
          padding: '24px',
          background: '#fff', 
          borderRadius: '8px',
          boxShadow: '0 1px 2px rgba(0, 0, 0, 0.03)'
        }}>
          <div style={{
            display: 'flex',
            gap: '16px',
            marginBottom: '24px',
            flexWrap: 'wrap'
          }}>
            <div style={{ flex: '1', minWidth: '300px' }}>
              <div style={{ marginBottom: '8px' }}>
                <label style={{
                  fontSize: '14px',
                  fontWeight: 500,
                  color: '#262626'
                }}>
                  Khoảng Thời Gian
                </label>
              </div>
              <StableDatePicker
                style={{
                  width: "100%",
                  borderRadius: "6px"
                }}
                onChange={handleDateChange}
                defaultValue={[
                  dayjs(adjustedfirstDayOfMonth),
                  dayjs(adjustedlastDayOfMonth),
                ]}
                format="YYYY-MM-DD"
                allowClear={false}
                placeholder={['Ngày bắt đầu', 'Ngày kết thúc']}
              />
            </div>

            <div style={{ flex: '1', minWidth: '300px' }}>
              <div style={{ marginBottom: '8px' }}>
                <label style={{
                  fontSize: '14px', 
                  fontWeight: 500,
                  color: '#262626'
                }}>
                  Chọn Team
                </label>
              </div>
              <Select
                value={selectedTeam}
                onChange={handleTeamChange}
                style={{ width: '100%' }}
              >
                {FilterTeam.map((data, index) => (
                  <Option key={index} value={data.value}>
                    {data.teamName}
                  </Option>
                ))}
              </Select>
            </div>
          </div>
        </div>

        <div style={{ 
          padding: '24px',
          background: '#fff',
          borderRadius: '8px',
          boxShadow: '0 1px 2px rgba(0, 0, 0, 0.03)',
          marginTop: '24px'
        }}>
          <List
            header={
              <Row style={{ width: '100%', padding: '16px 24px', borderBottom: '1px solid #f0f0f0' }}>
                <Col span={5}><strong style={{ color: '#262626' }}>Người Nhận</strong></Col>
                <Col span={5}><strong style={{ color: '#262626' }}>Số Sao Nhận</strong></Col>
                <Col span={5}><strong style={{ color: '#262626' }}>Số Sao Tích Lũy</strong></Col>
                <Col span={5}><strong style={{ color: '#262626' }}>Team</strong></Col>
                <Col span={4}><strong style={{ color: '#262626' }}>Chi Tiết</strong></Col>
              </Row>
            }
            dataSource={data}
            renderItem={(item: { receiverName: string, kudosSpendable: string, name: string, teamName: string, totalValue: string }, index: number) => (
              <List.Item style={{ padding: '16px 24px' }}>
                <Row style={{ width: '100%' }}>
                  <Col span={5}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <MedalIcon index={index} />
                      {item.receiverName}
                    </div>
                  </Col>
                  <Col span={5}>{item.totalValue}</Col>
                  <Col span={5}>{item.kudosSpendable}</Col>
                  <Col span={5}>{item.teamName}</Col>
                  <Col span={4}>
                    <Button type="primary">
                      <a href={`/app/users/top/detail?search=${item.name}${startDate && endDate ? `&startDate=${startDate}&endDate=${endDate}&FilterTeam=${selectedTeam}` : ''}`}>
                        Chi Tiết
                      </a>
                    </Button>
                  </Col>
                </Row>
              </List.Item>
            )}
            style={{
              background: '#fff',
              border: '1px solid #f0f0f0',
              borderRadius: '8px'
            }}
          />
        </div>

        <div style={{ marginTop: '20px' }}>
          <Button onClick={exportToExcel} type="primary">
            Export Excel
          </Button>
        </div>
      </Suspense>
    );
};

export default UserTopPage;